import Swiper, { Pagination, Navigation } from 'swiper'

const SwiperGuitar = function () {

  // configure Swiper to use modules
  const els = document.querySelectorAll( '.guitar-swiper' )

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const nextButton = el.querySelector( '.swiper-button-next');
      const prevButton = el.querySelector( '.swiper-button-prev');
      const swiper = new Swiper( el , {
        modules: [
          Pagination, 
          Navigation
        ],
        direction: 'horizontal',
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      })
    });
  }
}

// GUITARS PAGE SHOW / HIDE SPECS
let browserWidth = $(window).width();

$('.short-specs__btn').on('click keypress', function () {
  $(this).parent().parent().find('.full-specs').addClass('show-specs');
  $(this).parent().parent().find('.full-specs').scrollTop(-300);
  $('.short-specs, .desktop_guitar').addClass('filter-blur');
  $('body').css('overflow', 'hidden');
  $('.guitars-section').addClass('full-spec-index');
  if ( browserWidth < 992 ) {
    const scrollY = window.scrollY + "px"; // MODAL OVERFLOW FIXES
    document.body.style.top = `-${scrollY}`;
    document.body.style.position = 'fixed';
  }
});
$('.full-specs__content--close').on('click keypress', function () {
  $('.full-specs').removeClass('show-specs');
  $('.short-specs, .desktop_guitar').removeClass('filter-blur');
  $('body').css('overflow', 'auto');
  $('.guitars-section').removeClass('full-spec-index');
  if ( browserWidth < 992 ) {
    const scrollY = document.body.style.top; // MODAL OVERFLOW FIXES
    document.body.style.position = '';
    document.body.style.top = '';
    document.documentElement.style = "scroll-behavior: auto";
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });
  }
});

export default SwiperGuitar;